import { render, staticRenderFns } from "./PolicySuccess.vue?vue&type=template&id=58c3bdd4&scoped=true"
import script from "./PolicySuccess.vue?vue&type=script&lang=js"
export * from "./PolicySuccess.vue?vue&type=script&lang=js"
import style0 from "./PolicySuccess.vue?vue&type=style&index=0&id=58c3bdd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c3bdd4",
  null
  
)

export default component.exports